let mainPath = "/sync";
let viewFolder = "Sync";

module.exports = [
    {
        path: mainPath,
        name: 'sync',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]
